var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    y: 0.861816,
    width: 71.0144,
    height: 71.0144,
    rx: 35.5072,
    fill: "#4745B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0717 29.6399V35.7096H29.6884V37.6634H23.0717V43.9154H30.4699V45.8691H20.7012V27.6862H30.4699V29.6399H23.0717ZM42.3148 46.0515C40.5955 46.0515 39.0151 45.6521 37.5737 44.8532C36.1496 44.0543 35.0121 42.9428 34.1611 41.5188C33.3275 40.0773 32.9107 38.4622 32.9107 36.6735C32.9107 34.8847 33.3275 33.2783 34.1611 31.8542C35.0121 30.4301 36.1496 29.3187 37.5737 28.5198C39.0151 27.7209 40.5955 27.3215 42.3148 27.3215C44.0341 27.3215 45.6058 27.7209 47.0299 28.5198C48.4713 29.3187 49.6001 30.4301 50.4164 31.8542C51.25 33.2783 51.6668 34.8847 51.6668 36.6735C51.6668 38.4622 51.25 40.0773 50.4164 41.5188C49.5828 42.9428 48.4539 44.0543 47.0299 44.8532C45.6058 45.6521 44.0341 46.0515 42.3148 46.0515ZM42.3148 41.9877C43.7736 41.9877 44.9372 41.5014 45.8055 40.5289C46.6912 39.5563 47.1341 38.2712 47.1341 36.6735C47.1341 35.0584 46.6912 33.7732 45.8055 32.8181C44.9372 31.8455 43.7736 31.3592 42.3148 31.3592C40.8386 31.3592 39.6577 31.8368 38.772 32.792C37.9036 33.7472 37.4695 35.041 37.4695 36.6735C37.4695 38.2886 37.9036 39.5824 38.772 40.5549C39.6577 41.5101 40.8386 41.9877 42.3148 41.9877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventOrganization);
export default __webpack_public_path__ + "static/media/event-organization.80be472c30847ec24f3f3510faa9a010.svg";
export { ForwardRef as ReactComponent };